import React, { Component } from "react";
import StakeholderForm from "./StakeholderForm/StakeholderForm";
import SmallModal from "../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";

class Stakeholder extends Component {
  state = {
    project_stakeholder_id: null
  };

  componentDidMount() {
    this.props.stakeholder.fetch();
  }

  render() {
      /*
      const columns = [
          {
              Header: "ID",
              accessor: "agency_id",
              id: "agency_id",
              show: false
          },
          {
              Header: "Agency Name",
              accessor: "agency_name",
              headerStyle: { fontWeight: "bold" },
              minWidth: 255
          },
          {
              Header: "Agency Short Name",
              accessor: "agency_short_name",
              id: "agency_short_name",
              maxWidth: 250,
              headerStyle: { fontWeight: "bold" }
          },
          {
              Header: "State",
              accessor: "state_id",
              id: "state_id",
              maxWidth: 250,
              Cell: props => AllStates[props.value - 1].state_name,
              headerStyle: { fontWeight: "bold" }
          },
          {
              Header: "Budget Year",
              accessor: "budget_year",
              headerStyle: { fontWeight: "bold" },
              maxWidth: 200
          },
          {
              Header: "Capital Project Budget ($Mil)",
              accessor: "capital_project_budget",
              id: "capital_project_budget",
              maxWidth: 250,
              headerStyle: { fontWeight: "bold" },
              Cell: props =>
                  props.value ? props.value.toLocaleString() : props.value
          },
          {
              Header: "Agency Division",
              accessor: "agency_division",
              maxWidth: 400,
              id: "agency_division",
              headerStyle: { fontWeight: "bold" },
              Cell: props =>
                  props.value ? props.value.toLocaleString() : props.value
          }
      ];*/




      let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <StakeholderForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentStakeholder={
              this.props.stakeholder.stakeholder.filter(
                item =>
                  item.project_stakeholder_id ===
                  this.state.project_stakeholder_id
              )[0]
            }
            update={this.props.stakeholder.update}
            add={this.props.stakeholder.add}
            projectID={this.props.currentProjectID}
            disabled={this.props.disabled}
          />
        </SmallModal>
      );
    }

    this.props.stakeholder.stakeholder.sort((a, b) => {
        if (!a || !a.stakeholder_category) {
            return 1;
        }
        if (!b || !b.stakeholder_category) {
            return -1;
        }

        if (a.stakeholder_category.name < b.stakeholder_category.name) {
            return -1;
        }
        if (a.stakeholder_category.name > b.stakeholder_category.name) {
            return 1;
        }

        if (!a || !a.stakeholder_role) {
            return 1;
        }
        if (!b || !b.stakeholder_role) {
            return -1;
        }

        if (a.stakeholder_role.name < b.stakeholder_role.name) {
            return -1;
        }
        if (a.stakeholder_role.name > b.stakeholder_role.name) {
            return 1;
        }
        return 0;
    });

    return (
      <div className={"container-fluid"}>
          {this.props.disabled ? null : (
              <div
                  style={{textAlign: "right"}}
              >
            <Button
              className="my-2"
              color="blue"
              onClick={() => {
                this.setState({ project_stakeholder_id: null });
                this.props.toggleSmallModalHandler();
              }}
            >
              Create New Stakeholder
            </Button>
              </div>
          )}
        {smallModal}

        <table className="table">
          <thead>
            <tr>
            <th>Organization</th>
              <th>Category</th>
              <th>Role</th>
              <th>Notes</th>
                {this.props.disabled ? null : (<th>Action</th>)}
            </tr>
          </thead>
          <tbody>
            {this.props.stakeholder.stakeholder.map(item => (
              <tr
                key={item.project_stakeholder_id}
                onClick={e => {
                  if (e.target.type !== "button") {
                    this.setState({
                      project_stakeholder_id: item.project_stakeholder_id
                    });
                    this.props.toggleSmallModalHandler();
                  }
                }}
              >
                <td>{item.organization.name}</td>
                <td>
                  {item.stakeholder_category
                    ? item.stakeholder_category.name
                    : ""}
                </td>
                <td>
                  {item.stakeholder_role ? item.stakeholder_role.name : ""}
                </td>
                <td>{item.notes}</td>
                  {this.props.disabled ? null : (
                    <td>
                        <Button
                            type="button"
                            onClick={() =>
                                this.props.stakeholder.delete(
                                    item.project_stakeholder_id,
                                    this.props.currentProjectID
                                )
                            }
                            color="red"
                        >
                            Delete
                        </Button>
                    </td>
                  )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default Stakeholder;
